import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import Target2SellCarousel from "../../pages/OrderFunnel/Checkout/components/Target2SellCarousel";
import { translate } from "../../services/translation.service";
import theme from "../../theme";
import BlockWrapper from "../BlockWrapper";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const CarouselWrapper = styled.div`
  width: 100%;
  margin-top: ${theme.margins.marginBase};
  background-color: ${theme.colors.white};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`;

interface IImageWrapper {
  color: string;
}

const ImageWrapper = styled.img<IImageWrapper>`
  width: 120px;
  margin-top: 30px;
  margin-bottom: 40px;
  transform: translateX(13px);
  background-color: transparent;
  color: ${(props: IImageWrapper): string => props.color};
`;

const Text = styled.div`
  font-family: ${theme.fonts.subtitle};
  font-size: 18px;
`;

interface IProps {
  displayT2SCarousel?: boolean;
  imageColor?: string;
  onClick?: () => void;
}

type IDefaultProps = Required<Pick<IProps, "displayT2SCarousel">>;

export default class EmptyCart extends PureComponent<IProps, {}> {
  public static defaultProps: IDefaultProps = {
    displayT2SCarousel: false,
  };

  public render(): ReactNode {
    const imageColor = this.props.imageColor || theme.colors.white;

    return (
      <Wrapper>
        <ContentWrapper>
          <ImageWrapper
            src={require("../../assets/images/emptyCart.svg")}
            color={imageColor}
            alt={translate("emptyCart.yourEmptyCart")}
          />
          <BlockWrapper
            onClick={(): void => {
              if (this.props.onClick) {
                this.props.onClick();
              }
            }}
            validationText={translate("emptyCart.continueShopping")}
          >
            <FormFieldsWrapper>
              <Text>{translate("emptyCart.yourEmptyCart")}</Text>
            </FormFieldsWrapper>
          </BlockWrapper>
        </ContentWrapper>
        {this.props.displayT2SCarousel && (
          <CarouselWrapper>
            <Target2SellCarousel />
          </CarouselWrapper>
        )}
      </Wrapper>
    );
  }
}
